// extracted by mini-css-extract-plugin
export default {"rules":"Rules_rules__GstV7"};